import {
  SET_CANONICAL_NODES,
  SET_VIS_TO_WVR_MAP,
  SET_GRAPH_ADDING_EDGE,
  SET_GRAPH_COLOR_PICKER_PROPS,
  SET_GRAPH_CREATING_EDGE,
  SET_GRAPH_RENAME_RELATION_PROPS,
  SET_SHOW_ATTRIBUTES,
  SET_SHOW_RELEVANT_META_NODES,
  SET_SHOW_ALL_META_NODES,
  SET_QUERY_RESULTS,
  SET_RICH_NODE_MAP
} from './actionTypes'

export const setQueryResults = (data) => ({
  type: SET_QUERY_RESULTS,
  payload: { data }
})

export const setRichNodesMap = (data) => ({
  type: SET_RICH_NODE_MAP,
  payload: { data }
})

export const setShowAttributes = (data) => ({
  type: SET_SHOW_ATTRIBUTES,
  payload: { data }
})

export const setShowRelevantMetaNodes = (data) => ({
  type: SET_SHOW_RELEVANT_META_NODES,
  payload: { data }
})

export const setShowAllMetaNodes = (data) => ({
  type: SET_SHOW_ALL_META_NODES,
  payload: { data }
})

export const setCanonicalNodeIds = (data) => ({
  type: SET_CANONICAL_NODES,
  payload: { data }
})

export const setVisToWvrMap = (data) => ({
  type: SET_VIS_TO_WVR_MAP,
  payload: { data }
})

export const setGraphAddingEdge = (data) => ({
  type: SET_GRAPH_ADDING_EDGE,
  payload: { data }
})

export const setGraphColorPickerProps = (data) => ({
  type: SET_GRAPH_COLOR_PICKER_PROPS,
  payload: { data }
})

export const setGraphCreatingEdge = (data) => ({
  type: SET_GRAPH_CREATING_EDGE,
  payload: { data }
})

export const setGraphRenameRelationProps = (data) => ({
  type: SET_GRAPH_RENAME_RELATION_PROPS,
  payload: { data }
})
